import React from "react";
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";

import {WorkflowInput} from "common/flowmaster/types/workflow";
import {llmModels} from "modules/flowmaster/constants/models";

interface LlmInputSelectorProps {
  input: WorkflowInput;
  value: string;
  handleInputChange: (e: React.ChangeEvent<{value: string}>) => void;
  warning?: boolean;
  disabled?: boolean;
}
const LlmInputSelector: React.FC<LlmInputSelectorProps> = ({
  input,
  value,
  handleInputChange,
  warning = false,
  disabled = false,
  ...overrideProps
}) => {
  return (
    <FormControl
      key={input.id}
      style={{width: "30em", marginBottom: "1rem"}}
      disabled={disabled}
      {...overrideProps}
    >
      <InputLabel>{input.label || input.name}</InputLabel>
      <Select
        value={value}
        onChange={handleInputChange}
        style={{
          width: "20em",
          ...(warning ? {border: "1px solid orange"} : {}),
        }}
        displayEmpty
      >
        {llmModels.map(model => (
          <MenuItem key={model.key} value={model.key}>
            {model.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default {
  label: "LLM Model",
  component: LlmInputSelector,
};
